<!-- Mapová legenda -->
<!-- Základní seznam složek - první groups se svými layers -->
<template>
  <v-expansion-panels accordion multiple>
    <template v-for="item in MapLegendTree.groups">
      <v-expansion-panel v-if="Object.values(item.groups).length > 0 ||
        Object.values(item.layers).length > 0
      " :key="item.id" class="transparent">
        <!-- Hlavička -->
        <v-expansion-panel-header class="" :color="item.color">
          <v-row dense no-gutters>
            <v-col v-if="item.image">
              <v-avatar rounded color="green lighten-5" class="mr-3" width="70">
                <v-img :src="AssetsUrl + '/' + item.image" contain max-height="40" max-width="60">
                </v-img>
              </v-avatar>
            </v-col>
            <v-col align-self="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="accent2--text text-h6" v-html="item.label" />
                </template>
                <span>{{ item.labelsub }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content :color="item.color" class="">
          <!-- případné Podsložky -->
          <MapLegendGroups v-if="Object.values(item.groups).length > 0" :MapLegendTree="item" :AssetsUrl="AssetsUrl"
            :MapLayerLegend_view="MapLayerLegend_view" :MapLayerLegend_layerId="MapLayerLegend_layerId"
            :ServiceMap="ServiceMap" @MapLegendRemoveLayer="MapLegendRemoveLayer"
            @MapViewZoomToScale="MapViewZoomToScale" @MapLegendLayerChangeBaseURL="MapLegendLayerChangeBaseURL"
            @MapLayerLegendStaticSet="MapLayerLegendStaticSet" @MapLayerLegendDynamicSet="MapLayerLegendDynamicSet">
          </MapLegendGroups>

          <!-- Mapové vrstvy -->
          <MapLegendItem v-for="child in item.layers" :key="child.id" :MapLegendLayer="child" :AssetsUrl="AssetsUrl"
            :MapLayerLegend_view="MapLayerLegend_view" :MapLayerLegend_layerId="MapLayerLegend_layerId"
            :ServiceMap="ServiceMap" @MapLegendRemoveLayer="MapLegendRemoveLayer"
            @MapViewZoomToScale="MapViewZoomToScale" @MapLegendLayerChangeBaseURL="MapLegendLayerChangeBaseURL"
            @MapLayerLegendStaticSet="MapLayerLegendStaticSet" @MapLayerLegendDynamicSet="MapLayerLegendDynamicSet">
          </MapLegendItem>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </v-expansion-panels>
</template>

<script>
export default {
  props: {
    // Legenda - základní seznam složek
    MapLegendTree: Object,
    // Adresa na Assets
    AssetsUrl: null,
    // Mapová služba
    ServiceMap: null,
    // Viditelnost legendy
    MapLayerLegend_view: null,
    // id vrstvy, ke které se legenda vztahuje
    MapLayerLegend_layerId: null,
  },

  components: {
    MapLegendGroups: () => import("./MapLegendGroups.vue"),
    MapLegendItem: () => import("./MapLegendItem.vue"),
  },

  methods: {

    // Změna mapového výřezu na cílové měřítko - volá se funkce v nadřazeném objektu
    MapViewZoomToScale: function (value) {
      this.$emit('MapViewZoomToScale', value);
    },
    // Funkce pro odstranění vrstvy - volá se funkce v nadřazeném objektu
    MapLegendRemoveLayer: function (id) {
      this.$emit('MapLegendRemoveLayer', id);
    },
    // Funkce pro změnu zdroje vrstvy - volá se funkce v nadřazeném objektu
    MapLegendLayerChangeBaseURL: function (id, oldValue, newValue) {
      this.$emit('MapLegendLayerChangeBaseURL', id, oldValue, newValue);
    },
    // Statická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendStaticSet: function (layerId, title, content) {
      this.$emit('MapLayerLegendStaticSet', layerId, title, content);
    },
    // Dynamická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendDynamicSet: function (layerId, title, content) {
      this.$emit('MapLayerLegendDynamicSet', layerId, title, content);
    },


  },


};
</script>
